const KeenSlider = window.KeenSlider
const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class SliderTabsRecommendations extends HTMLElement {
  connectedCallback () {
    this.fetchImmediate = this.hasAttribute('data-fetch-immediate')
    if (this.fetchImmediate) {
      this.render()
    } else {
      this.setupTabListener()
    }
  }

  setupTabListener () {
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.SLIDER_TABS.TAB_CHANGED,
      this.handleTabChange.bind(this),
    )
  }

  handleTabChange (e) {
    const carousel = this.closest('slider-tabs-carousel')
    if (!carousel || carousel.dataset.tab !== e.detail.tabId) return
    if (this.hasAttribute('data-loaded')) return
    this.render()
  }

  async render () {
    const url = this.dataset.url
    if (!url) {
      console.error('SliderTabsRecommendations: No URL provided.')
      return
    }

    try {
      const response = await fetch(url)
      const text = await response.text()

      const html = document.createElement('div')
      html.innerHTML = text
      const content = html.querySelector('slider-tabs-recommendations-content')

      if (content && content.innerHTML.trim()) {
        this.innerHTML = content.innerHTML
        this.setAttribute('data-loaded', '')
        this.setupCarousel()
      }
    } catch (error) {
      console.error('SliderTabsRecommendations: Error fetching recommendations.', error)
    }
  }

  setupCarousel () {
    const slidesElement = this.querySelector('[data-slider-tabs-carousel-el="slides"]')
    if (!slidesElement) return

    const carousel = this.closest('slider-tabs-carousel')
    const next = carousel?.querySelector('[data-slider-tabs-carousel-el="next"]')
    const prev = carousel?.querySelector('[data-slider-tabs-carousel-el="prev"]')
    const spacing = Number(carousel?.dataset.blockGap)
    const spacingValue = Number.isNaN(spacing) == true ? 5 : spacing

    new KeenSlider(
      slidesElement,
      {
        selector: '[data-slider-tabs-carousel-el="slide"]',
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 2.25,
          spacing: spacingValue,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 4,
              spacing: spacingValue,
            },
          }
        },
      },
      [
        setInitialised(),
        useArrows({
          next: next,
          previous: prev,
        }),
      ],
    )
  }
}

customElements.define('slider-tabs-recommendations', SliderTabsRecommendations)